<template>
  <v-container class="fill-height justify-center">
    <div class="d-flex justify-center align-center">
      <v-card elevation="0">
        <v-card-text>
          <v-row class="justify-space-between align-center">
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 1 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" :to="'/coa'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="primary">mdi-file-cog</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    CoA
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 52 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/set-saldo-awal'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="red">mdi-currency-usd</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Set Saldo Awal
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 4 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/jurnal'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="warning">mdi-file-document-edit-outline</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Jurnal
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 5 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/buku-besar'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                <!-- <v-card min-width="120" class="rounded-lg" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }"> -->
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="success">mdi-book-open-blank-variant</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Buku Besar
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 2 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/neraca'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="accent">mdi-scale-balance</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2"> Neraca </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 3 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/laba-rugi'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="pink">mdi-chart-bell-curve-cumulative</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Laba Rugi
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 6 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/trial-balance'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#3E2723">mdi-book-remove</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Tutup Buku
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 7 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/project'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#00838F">mdi-folder-account</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Project
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <!-- <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 8 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/divisi'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="#BF360C">mdi-bookmark-box</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2"> Divisi </v-card-text>
                </v-card>
              </v-hover>
            </v-col> -->
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 53 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/laporan-sub-keuangan'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#827717">mdi-file-document</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Laporan Sub Keuangan
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 11 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/user'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="primary">mdi-account-group</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Pegawai
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <!-- <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 12 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/category-user'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                    <v-icon size="60" color="#4A148C">mdi-shape</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Kategori Pegawai
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col> -->
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 57 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/arus-kas'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="#1565C0">mdi-file-chart-outline</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Laporan Alur Kas
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            <v-col cols="12" md="3" v-if="menu.filter(function(v) { return v.id === 55 }).length > 0">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/cashflow'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="80">
                      <v-icon size="60" color="#00695C">mdi-cash-fast</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    Laporan Konsolidasi Kas
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col>
            
            <!-- <v-col cols="12" md="2">
              <v-hover v-slot="{ hover }">
                <v-card min-width="120" class="rounded-lg" :to="'/ake/music'" :elevation="hover ? 1 : 0" :class="{ 'on-hover': hover }">
                  <v-card-title class="justify-center">
                    <v-avatar size="128">
                      <v-icon size="60" color="#D400B8">mdi-cellphone</v-icon>
                    </v-avatar>
                  </v-card-title>
                  <v-card-text class="text-center subtitle-2">
                    AKE
                  </v-card-text>
                </v-card>
              </v-hover>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
export default {
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
    menu() {
      return this.$store.state.menu;
    },
  },

  mounted() {
    this.fetchDetail();
  },

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },
    async fetchDetail () {
      await get(`account/data`)
      .then(response => {
        let res = response.data

        // this.process.load = false
          
        if (res.status === 200) {
          // this.form = res.results.data
        }
      })
    },
  },
};
</script>

<style>
</style>